import React from "react"
import accessibleSvg from "src/utils/accessibleSvg"

export default accessibleSvg(({ children, ...props }) => (
  <svg
    fill="currentColor"
    viewBox="0 0 100 100"
    width="100"
    height="100"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {children}
    <path
      id="Flag"
      fillRule="evenodd"
      d="M50,100c49.614,0,50-22.386,50-50S99.614,0,50,0,0,22.386,0,50,0.386,100,50,100ZM35,28V25.5A1.5,1.5,0,0,0,33.5,24h-3A1.5,1.5,0,0,0,29,25.5v49A1.5,1.5,0,0,0,30.5,76h3A1.5,1.5,0,0,0,35,74.5V62H49v4.5A1.5,1.5,0,0,0,50.5,68h23A1.5,1.5,0,0,0,75,66.5v-31A1.5,1.5,0,0,0,73.5,34H55V29.5A1.5,1.5,0,0,0,53.5,28H35Zm0,6V56H49V34H35Zm34,6H55V62H69V40Z"
    />
  </svg>
))
